let meet = {
  selectCallNet: {
    //发起会议

    /***将多个号码连接一起进行多方通话(语音通话)，主叫号码也会进入会议。
      发起会议的结果以 通知 的方式告知
    **/
    url: '/dispatch-web/api/call/selectCall',
    method: 'POST',
    requestParam: {
      token: '',
      caller: '',
      //主叫号码 （一般使用坐席号码）
      callees: '',
      //多个成员号码
      type: '',
      //类型：默认为0. 【0】加入默认会场 【1】新创建会场，并将成员加入会场中。
      meetId: '' //type=1的情况下需要自定义会场id，且保证不重复。建议使用操作员名称+时间戳（如不设置，则由平台自动生成）

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {}
    }
  },
  MeetPrivateTalkNet: {
    //会场成员单独通话

    /***会场成员单独通话 坐席号码与会场成员单独通话，坐席号码与会场成员单独通话后可通过回到会场方法，让会场成员回到会场
    **/
    url: '/dispatch-web/api/meet/privateTalk',
    method: 'POST',
    requestParam: {
      token: '',
      meetId: '',
      //会场id
      tel: '' //成员号码

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {}
    }
  },
  MeetBackToNet: {
    //回到会场

    /***回到会场，坐席号码与会场成员单独通话后执行该方法可让该成员回到会场
    **/
    url: '/dispatch-web/api/meet/backToMeet',
    method: 'POST',
    requestParam: {
      token: '',
      meetId: '',
      //会场id
      tel: '' //成员号码

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {}
    }
  },
  endMeetNet: {
    //结束会议

    /***结束会议，踢出所有的与会人员
    **/
    url: '/dispatch-web/api/meet/endMeet',
    method: 'POST',
    requestParam: {
      token: '',
      id: '' //会场id

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {}
    }
  },

  /**
   * 创建空的会场
   */
  createMeetNet: {
    url: '/dispatch-web/api/meet/createMeet',
    method: 'POST',
    requestParam: {
      token: '',
      bussinessId: '',
      name: '',
      //会场名称
      meetAcess: '',
      //会场号,9位纯数字且会议号不可重复 保证唯一性,若设置，成员可通过拨会场号加入会场(只能设置数字)；若不设置，成员无法加入会场
      meetAttr: '',
      //会议类别 MEET_INSTANT: 即时会议（默认），MEET_RESERVE: 预约会议
      timeBegin: '',
      //会议开始时间
      timeEnd: '',
      //会议结束时间
      passwdSpeaker: '',
      //成员密码，只能设置数字
      passwdAudience: '',
      //听众密码，只能设置数字
      meetMembers: '' //预设参会成员 格式：成员号码,成员角色， 每个成员间用';'分隔  如："1001,speak;1002,speak;1003,chairman"  角色：chairman（主持人，只能有一个）；  状态：speak（可发言，默认）；audience（禁言）

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {
        meetId: '' //会场ID

      }
    }
  },

  /**
   * 销毁会场
   */
  destroyMeetNet: {
    url: '/dispatch-web/api/meet/destroyMeet',
    method: 'POST',
    requestParam: {
      token: '',
      id: ''
    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {}
    }
  },

  /**
   * 更改会场成员状态
   */
  changeMemeberLevelNet: {
    url: '/dispatch-web/api/meet/changeMemberLevel',
    method: 'POST',
    requestParam: {
      token: '',
      id: '',
      tel: '',
      level: '' //成员会议状态，类型选择：speak（可发言, 默认）；audience（禁言）

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {}
    }
  },

  /**
   * 踢出会场中的成员 成员号码不挂断，而是以保持状态存在。
    如需要直接踢出并挂断会场成员，直接对该成员号码做 拆线/挂断 操作即可
   */
  kickMemberNet: {
    url: '/dispatch-web/api/meet/kickMember',
    method: 'POST',
    requestParam: {
      token: '',
      id: '',
      tel: ''
    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {}
    }
  },

  /**
   * 设置主持人
   */
  setMeetChairmanNet: {
    url: '/dispatch-web/api/meet/setMeetChairman',
    method: 'POST',
    requestParam: {
      token: '',
      id: '',
      tel: ''
    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {}
    }
  },
  joinVideoMemberNet: {
    //成员加入会场（视频）

    /***成员加入会场，具体以语音或视频的哪种方式发起呼叫由号码配置类型决定
      如果坐席号码加入会场，且会场中没有主持人，则坐席号码自动升级为主持人角色。
      如果要将会场成员踢出，调用拆线接口即可
    **/
    url: '/dispatch-web/api/meet/joinVideoMember',
    method: 'POST',
    requestParam: {
      token: '',
      meetId: '',
      businessId: '',
      //业务Id，用于业务操作与相关功能的关联。
      tel: '',
      level: '' //成员会场等级类型选择：状态：speak（可发言，默认）；audience（禁言

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {}
    }
  },
  joinMemberNet: {
    //成员加入会场（语音）

    /***成员加入会场，具体以语音或视频的哪种方式发起呼叫由号码配置类型决定
      如果坐席号码加入会场，且会场中没有主持人，则坐席号码自动升级为主持人角色。
      如果要将会场成员踢出，调用拆线接口即可
    **/
    url: '/dispatch-web/api/meet/joinMember',
    method: 'POST',
    requestParam: {
      token: '',
      meetId: '',
      businessId: '',
      //业务Id，用于业务操作与相关功能的关联。
      tel: '',
      level: '' //成员会场等级类型选择：状态：speak（可发言，默认）；audience（禁言

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {}
    }
  },
  listMeetsNet: {
    //查询会场列表

    /***查询当前所有会场信息
    **/
    url: '/dispatch-web/api/meet/listMeets',
    method: 'POST',
    requestParam: {
      token: ''
    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {
        total: '',
        list: [{
          meetId: '',
          meetName: '',
          chairman: '',
          //主持人号码
          recording: '',
          //是否在录音
          playvoice: '',
          //是否在放音
          locked: '',
          //是否锁定
          list: [{
            meetId: '',
            tel: '',
            level: '' //成员会场 角色/状态 ,类型如下：角色：chairman（主持人） 状态：speak（可发言）；audience（禁言）

          }]
        }]
      }
    }
  },
  getMeetNet: {
    //查询单个会场信息

    /***查询当前所有会场信息
    **/
    url: '/dispatch-web/api/meet/getMeetAdd',
    method: 'POST',
    requestParam: {
      token: '',
      meetId: ''
    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {
        meetId: '',
        meetName: '',
        chairman: '',
        //主持人号码
        recording: '',
        //是否在录音
        playvoice: '',
        //是否在放音
        locked: '',
        //是否锁定
        members: [{
          meetId: '',
          tel: '',
          level: '' //成员会场 角色/状态 ,类型如下：角色：chairman（主持人） 状态：speak（可发言）；audience（禁言）

        }]
      }
    }
  },
  listMeetMembersNet: {
    //查询与会成员列表

    /***查询当前会场所有成员信息。
    **/
    url: '/dispatch-web/api/meet/listMeetMembers',
    method: 'POST',
    requestParam: {
      token: '',
      meetId: ''
    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {
        total: '',
        list: [{
          meetId: '',
          tel: '',
          level: '' //成员会场 角色/状态 ,类型如下：角色：chairman（主持人） 状态：speak（可发言）；audience（禁言）

        }]
      }
    }
  },
  meetStatusMQNet: function (accId) {
    return {
      //会场状态改变通知
      topic: `/${accId}/dispatch-web/notify/meet/meetStatus`,
      responseParam: {
        id: 0,
        //数据id
        type: 'meetStatus',
        //消息类别
        source: 'dispatch-web',
        //消息来源
        data: {
          //通知的具体消息
          meetId: '',
          meetName: '',
          destory: '',
          //是否删除  true: 会场被销毁 false: 会场新创 or 已存在会场状态改变
          chairman: '',
          //主持人号码 F
          accId: '',
          //消息接收的账号id
          account: '' //消息接收的账号名

        }
      }
    };
  },
  memberMQNet: function (accId) {
    return {
      //会场成员列表改变通知
      topic: `/${accId}/dispatch-web/notify/meet/member`,
      responseParam: {
        id: 0,
        //数据id
        type: 'member',
        //消息类别
        source: 'dispatch-web',
        //消息来源
        data: {
          //通知的具体消息
          meetId: '',
          tel: '',
          type: '',
          // 成员列表改变类型 add: 加入会场 del：退出会场
          level: '',
          //会场成员状态
          accId: '',
          //消息接收的账号id
          account: '' //消息接收的账号名

        }
      }
    };
  },
  selectCallMQNet: function (accId) {
    return {
      //发起会议结果通知
      topic: `/${accId}/dispatch-web/notify/call/selectCall`,
      responseParam: {
        id: 0,
        //数据id
        type: 'selectCall',
        //消息类别
        source: 'dispatch-web',
        //消息来源
        data: {
          //通知的具体消息
          result: '',
          //操作结果
          desc: '',
          //选呼结文字描述
          accId: '',
          //消息接收的账号id
          account: '' //消息接收的账号名

        }
      }
    };
  },
  meetStatusHttpNet: {
    //会场状态改变通知Http推送方式
    url: '/notify/meet/meetStatus',
    method: 'POST',
    //推送当前会场状态改变通知
    requestParam: {
      meetId: '',
      meetName: '',
      accId: '',
      //消息接收的账号id
      account: '' //消息接收的账号名

    },
    responseParam: {
      code: '' //返回结果状态码

    }
  },
  selectCallHttpNet: {
    //发起会议结果通知Http推送方式
    url: '/notify/call/selectCall',
    method: 'POST',
    //推送选呼结果
    requestParam: {
      result: '',
      desc: '',
      accId: '',
      //消息接收的账号id
      account: '' //消息接收的账号名

    },
    responseParam: {
      code: '' //返回结果状态码

    }
  },
  memberHttpNet: {
    //会场成员列表改变通知Http推送方式
    url: '/notify/meet/member',
    method: 'POST',
    //推送当前会场成员列表改变通知，即单个会场成员的增加或删除通知消息
    requestParam: {
      meetId: '',
      tel: '',
      type: '',
      //列表更新状态  add: 新增会场  del：销毁会场
      level: '',
      // 成员会场 角色/状态  角色：chairman（主持人）状态：speak（可发言）；audience（禁言） F
      accId: '',
      //消息接收的账号id
      account: '' //消息接收的账号名

    },
    responseParam: {
      code: '' //返回结果状态码

    }
  }
};
export default meet;